import React, { useState } from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { IoFastFood } from "react-icons/io5";

function Footer() {
  const [showContact, setShowContact] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showAbout, setShowAbout] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    // After 3 seconds, close the contact panel
    setTimeout(() => {
      setShowContact(false);
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="relative mt-20 bg-orange-500 py-14">
      
      {/* CONTACT PANEL */}
      {showContact && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-[90%] max-w-md relative">
            <button 
              className="absolute top-4 right-4 text-black font-bold text-xl"
              onClick={() => {
                setShowContact(false);
                setSubmitted(false);
              }}
            >
              ✕
            </button>

            {!submitted ? (
              <>
                <h2 className="text-2xl font-bold text-orange-500 mb-6 text-center">Contact Us</h2>
                <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                  <input type="text" placeholder="Your Name" className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400" required />
                  <input type="email" placeholder="Your Email" className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400" required />
                  <textarea placeholder="Your Message" rows="4" className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400" required></textarea>
                  <button type="submit" className="bg-orange-500 hover:bg-orange-600 text-white rounded-full py-3 font-semibold">Send</button>
                </form>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-[250px]">
                <h2 className="text-2xl font-bold text-green-600 mb-4">Thank You!</h2>
                <p className="text-gray-700 text-center">Your message has been successfully sent. We will contact you soon!</p>
              </div>
            )}
          </div>
        </div>
      )}



      {/* ABOUT PANEL */}
{showAbout && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-2xl shadow-2xl p-8 w-[90%] max-w-md relative">
      <button 
        className="absolute top-4 right-4 text-black font-bold text-xl"
        onClick={() => setShowAbout(false)}
      >
        ✕
      </button>

      <div className="flex flex-col items-center justify-center">
        <h2 className="text-2xl font-bold text-orange-500 mb-6">About SnapEats</h2>
        <p className="text-gray-700 text-center leading-relaxed">
          SnapEats was born out of a simple idea: to bring your favorite meals to your doorstep in record time! 🚀
          <br/><br/>
          We’re passionate about food, fast service, and happy smiles. 
          Thanks for trusting us to feed your cravings! 🍔🍟
        </p>
      </div>
    </div>
  </div>
)}





      {/* Glass Card */}
      <div className="max-w-7xl mx-auto px-6 py-14 flex flex-col md:flex-row justify-between items-center gap-12 backdrop-blur-md bg-white/50 rounded-3xl shadow-2xl"
        style={{ paddingLeft: "100px", paddingRight: "100px" }}>

        {/* Company Info */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center gap-3 mb-5">
            <IoFastFood className="w-14 h-14 text-orange-500" />
            <span className="text-4xl font-extrabold text-red-700">SnapEats</span>
          </div>
          <p className="text-gray-700 text-base leading-relaxed font-medium max-w-[250px]">
            Craving something delicious? <br />
            We deliver your favorites at lightning speed!
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col items-center md:items-center">
          <h4 className="text-2xl text-red-700 font-bold mb-6">Quick Links</h4>
          <ul className="space-y-4 text-center">
            <li><a href="#" className="text-gray-700 hover:text-orange-500 font-semibold transition-all duration-300">Home</a></li>
            <li><a href="#" className="text-gray-700 hover:text-orange-500 font-semibold transition-all duration-300">Menu</a></li>
            <li>
  <button 
    className="text-gray-700 hover:text-orange-500 font-semibold transition-all duration-300"
    onClick={() => setShowAbout(true)}
  >
    About Us
  </button>
</li>            <li>
              <button
                className="w-fit px-8 py-3 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 hover:text-white transition mt-4"
                onClick={() => setShowContact(true)}
              >
                Contact
              </button>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="flex flex-col h-[146px] justify-start items-center">
          <h4 className="text-2xl text-red-700 font-bold mb-6">Follow Us</h4>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-700 hover:text-orange-500 text-3xl transition-transform hover:scale-125 duration-300"><FaFacebookF /></a>
            <a href="#" className="text-gray-700 hover:text-orange-500 text-3xl transition-transform hover:scale-125 duration-300"><FaTwitter /></a>
            <a href="#" className="text-gray-700 hover:text-orange-500 text-3xl transition-transform hover:scale-125 duration-300"><FaInstagram /></a>
            <a href="#" className="text-gray-700 hover:text-orange-500 text-3xl transition-transform hover:scale-125 duration-300"><FaLinkedinIn /></a>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="text-center text-gray-800 text-base py-3 font-semibold">
        © 2025 SnapEats. Crafted with ❤️. TYBCA PROJECT 2025
      </div>
    </div>
  );
}

export default Footer;
